import { createFileRoute } from '@tanstack/react-router';
import { GanttView } from '@/features/gantt/gantt-view';
import { requireGanttFeature } from '@/features/gantt/guard';
import { parseGanttSearch, withGanttTask } from '@/features/gantt/gantt-search';
import { useProject } from '@/features/projects/use-project';
import { TaskPanel } from '@/features/tasks/task-panel';

/** GANTT-01..09: plan of a project; zoom and order in the URL, `?task=KEY-1` opens the panel. */
export const Route = createFileRoute('/_app/p/$projectKey/gantt')({
  validateSearch: (raw: Record<string, unknown>) => parseGanttSearch(raw),
  beforeLoad: ({ context }) => requireGanttFeature(context.queryClient),
  component: RouteComponent,
});

function RouteComponent() {
  const { projectKey } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const project = useProject(projectKey);
  const linkTo = (key: string) => ({
    to: '/p/$projectKey/gantt' as const,
    params: { projectKey: project.key },
    search: withGanttTask(search, key),
  });
  return (
    <>
      <GanttView
        key={project.id}
        project={project}
        search={search}
        onSearchChange={(next) => {
          void navigate({ search: next, replace: true });
        }}
        onOpen={(key) => {
          void navigate({ search: withGanttTask(search, key) });
        }}
      />
      <TaskPanel
        projectKey={project.key}
        taskKey={search.task}
        linkTo={linkTo}
        onTaskChange={(key, options) => {
          void navigate({ search: withGanttTask(search, key), replace: options?.replace === true });
        }}
      />
    </>
  );
}
